import React from 'react';

function ImageMorpher () {
    return(
        <div>
            <h2>
                Web Version
            </h2>
            <a href='https://imagemorpher-mobile.vercel.app/'>https://imagemorpher-mobile.vercel.app/</a>

            <h2>
                iOS App Store
            </h2>
            <a href='https://apps.apple.com/us/app/mymorph/id1554421298'>https://apps.apple.com/us/app/mymorph/id1554421298</a>
        </div>
    )
}

export default ImageMorpher;
